var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { CustomElement, Component, html, Prop, State, classMap, styleMap, nothing, Interceptor } from '@sick-davinci/ce-decorators';
import { style } from './Balloon.style';
import { IconRef } from './../icon/IconRef';
import { icon_error } from '@sick-davinci/material-icons/alert/error.icon';
import { icon_warning } from '@sick-davinci/material-icons/alert/warning.icon';
import { icon_info } from '@sick-davinci/material-icons/action/info.icon';
export
/**
 * A `davinci-balloon` displays an overlay on top of a specified element.
 * 
 * @example
 * ```html
 * <davinci-button
 *   id="mybutton"
 *   onMouseEnter="document.querySelector('.myBalloon').show = true;"
 *   onClick="document.querySelector('.myBalloon').show = false;"
 * >Click Me</davinci-button>
 * 
 * <davinci-balloon
 *   class="myBalloon"
 *   position="right"
 *   for="mybutton"
 * >Just click the button</davinci-balloon>
 * ```
 * @slot {*} default - content inside balloon
 */
let Balloon = (_dec = Component({
  tag: 'davinci-balloon',
  style: [style],
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Prop({
  type: String
}), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Prop({
  type: String
}), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop({
  type: String
}), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop({
  type: Boolean
}), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop({
  type: Boolean
}), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop({
  type: String
}), _dec17 = Reflect.metadata("design:type", String), _dec18 = State(), _dec19 = Reflect.metadata("design:type", Object), _dec20 = Interceptor('icon'), _dec21 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = class Balloon extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "position", _descriptor, this);

    _initializerDefineProperty(this, "alignment", _descriptor2, this);

    _initializerDefineProperty(this, "for", _descriptor3, this);

    _initializerDefineProperty(this, "type", _descriptor4, this);

    _initializerDefineProperty(this, "headline", _descriptor5, this);

    _initializerDefineProperty(this, "show", _descriptor6, this);

    _initializerDefineProperty(this, "modal", _descriptor7, this);

    _initializerDefineProperty(this, "icon", _descriptor8, this);

    _initializerDefineProperty(this, "layoutInfo", _descriptor9, this);

    _defineProperty(this, "_animationFrameCallback", null);
  }

  render() {
    return html`<div class="transformdetector"></div>
                <div class="modal">
                  <div class="overlay"></div>
                  <div class=${classMap({
      flex: true,
      top: this.layoutInfo.position === 'top',
      bottom: this.layoutInfo.position === 'bottom',
      right: this.layoutInfo.position === 'right',
      left: this.layoutInfo.position === 'left',
      alignbottom: this.layoutInfo.alignment === 'bottom',
      alignright: this.layoutInfo.alignment === 'right'
    })} style=${styleMap({
      top: this.layoutInfo.top,
      left: this.layoutInfo.left,
      bottom: this.layoutInfo.bottom,
      right: this.layoutInfo.right
    })}>
                    <div class="tip tipShadow"></div>
                    <div class="tip"></div>
                    <div class="slot">
                      ${this.headline ? html`<div class="headline">
                                                <davinci-icon-ref style="${styleMap({
      display: this.icon ? '' : 'none'
    })}" .src="${this.icon}"></davinci-icon-ref>
                                                <span>${this.headline}</span></div>` : nothing}
                      <slot></slot>
                    </div>
                  </div>
                </div>
                </div>`;
  }

  componentConnected() {
    this._startLayouting();
  }

  componentDisconnected() {
    this._stopLayouting();
  }

  iconIntereptor(_oldvalue, newValue) {
    if (newValue === 'info') {
      return icon_info;
    } else if (newValue === 'warning') {
      return icon_warning;
    } else if (newValue === 'error') {
      return icon_error;
    } else {
      return newValue;
    }
  }

  _startLayouting() {
    this._layoutBalloon();
  }

  _stopLayouting() {
    window.cancelAnimationFrame(this._animationFrameCallback);
    this._animationFrameCallback = null;
  }

  _getTargetElement() {
    if (!this.for) {
      return null;
    }

    if (this.for instanceof Element) {
      return this.for;
    }

    if (this.for === ':before') {
      return this.previousElementSibling;
    }

    if (this.for === ':after') {
      return this.nextElementSibling;
    }

    return document.querySelector('#' + this.for);
  }

  _layoutBalloon() {
    const targetElement = this._getTargetElement();

    if (this.shadowRoot && targetElement && this.show) {
      // for IE we have to also check if shadow root is active, could be deffered some ticks
      this._layoutOverlayWrapper(); // boundingRect for target element


      const targetElementBounds = targetElement.getBoundingClientRect();
      const slotElement = this.shadowRoot.querySelector('.slot');
      const balloonWidth = slotElement.offsetWidth; // this should be a close-enough estimate for the balloon's width

      const balloonHeight = slotElement.offsetHeight; // this should be a close-enough estimate for the balloon's height

      let computedPosition = {
        position: this.position,
        alignment: this.alignment
      };
      const layoutInfo = { ...this.layoutInfo
      }; // margin around balloon = 2 x 1.429rem (~40px)

      const positionInformation = {
        rightSpace: document.documentElement.clientWidth - targetElementBounds.right - 40,
        leftSpace: targetElementBounds.left - 40,
        topSpace: targetElementBounds.top - 40,
        bottomSpace: document.documentElement.clientHeight - targetElementBounds.bottom - 40,
        viewportWidth: document.documentElement.clientWidth,
        viewportHeight: document.documentElement.clientHeight
      }; // check for enough space to display balloon, alter the position or alignment if not enough space

      if (this.position === 'top') {
        computedPosition = this._calcElementAlternatePosition(positionInformation, computedPosition, balloonWidth, balloonHeight, ['top', 'right', 'left', 'bottom']);
      } else if (this.position === 'bottom') {
        computedPosition = this._calcElementAlternatePosition(positionInformation, computedPosition, balloonWidth, balloonHeight, ['bottom', 'right', 'left', 'top']);
      } else if (this.position === 'left') {
        computedPosition = this._calcElementAlternatePosition(positionInformation, computedPosition, balloonWidth, balloonHeight, ['left', 'bottom', 'top', 'right']);
      } else if (this.position === 'right') {
        computedPosition = this._calcElementAlternatePosition(positionInformation, computedPosition, balloonWidth, balloonHeight, ['right', 'bottom', 'top', 'left']);
      } // populate the layoutInfo for render


      layoutInfo.position = computedPosition.position;
      layoutInfo.alignment = computedPosition.alignment;

      this._adjustBalloonInsetsToPosition(layoutInfo, targetElementBounds);

      this._adjustBalloonInsetsToAlignment(layoutInfo, targetElementBounds);

      this.layoutInfo = layoutInfo;
    }

    this._animationFrameCallback = window.requestAnimationFrame(() => {
      Promise.resolve().then(() => {
        this._layoutBalloon();
      });
    });
  }

  _layoutOverlayWrapper() {
    // on android, iphone and i pad document.document.clientElement.clientWidth/Height pretends the url bar is always visible even when hidden and report a wrong value
    // on desktop browsers window.innerWidth/Height also includes the scollbars and we have to subtract them thus using document.documentElement.clientHeight
    // https://stackoverflow.com/questions/14388367/mobile-safari-window-height-url-bar-discrepancy
    // does not work on ios13
    // TODO: detect if on mobile browser an add hidden url bar to height
    // TODO: Add detection of ios rubberband effect
    // TODO: create a lit-html directive for this logic to be reusasble
    const windowHeight = document.documentElement.clientHeight;
    const windowWidth = document.documentElement.clientWidth; // check if the element is in a style.transform context and resize overlay accordingly
    // a transform: translate..(..) will create a new containing block with the bounds of the
    // transformed element as viewport (fixed will then be positioned relative to this new containing block)

    const transformDetectorRect = this.shadowRoot && this.shadowRoot.querySelector('.transformdetector').getBoundingClientRect(); // check if element is somehow in a translated context
    // following must be true to be in a translated context
    // 1. transformDetectorRect.top must be !== 0:                        if we are in a translated context we have a new containing block so the overlay with style top: 0 is
    //                                                                    layouted relative to the element rather than the viewport
    // 2. transformDetectorRect.left must be !== 0:                       if we are in a translated context we have a new containing block so the overlay with style left: 0 is
    //                                                                    layouted relative to the element rather than the viewport
    // 3. transformDetectorRect.width must be !== windowWidth && !== 0:   usually the wrapper spans the whole viewpoert width with position fixed, if in a translated context
    //                                                                    the wrapper spans the width of the elements containing block.
    //                                                                    the !== 0 is to detect a false positive => if we are not translated the overlay has a width of 0
    //                                                                    in the animationFrame callback because it is not yet layouted, so we have to assume we are not in
    //                                                                    a transformed containing block
    // 3. transformDetectorRect.height must be !== windowHeight && !== 0: usually the wrapper spans the whole viewpoert width with position fixed, if in a translated context
    //                                                                    the wrapper spans the width of the elements containing block.
    //                                                                    the !== 0 is to detect a false positive => if we are not translated the overlay has a width of 0
    //                                                                    in the animationFrame callback because it is not yet layouted, so we have to assume we are not in
    //                                                                    a transformed containing block
    // if either one of these 3 expressions are true we have to manually adapt the overlay to the viewport
    // known bugs: transform rotate or scale does not work!

    const isTranslated = transformDetectorRect.top !== 0 || transformDetectorRect.left !== 0 || transformDetectorRect.width !== windowWidth && transformDetectorRect.width !== 0 || transformDetectorRect.height !== windowHeight && transformDetectorRect.height !== 0;
    const overlaywrapper = this.shadowRoot.querySelector('.modal');

    if (isTranslated) {
      Object.assign(overlaywrapper.style, {
        left: -transformDetectorRect.left + 'px',
        top: -transformDetectorRect.top + 'px',
        height: windowHeight + 'px',
        width: windowWidth + 'px',
        right: 'auto',
        bottom: 'auto'
      });
    } else {
      Object.assign(overlaywrapper.style, {
        left: null,
        top: null,
        height: null,
        width: null,
        right: null,
        bottom: null
      });
    }
  }

  _adjustAlignmentToPosition(position, selectedAlignment) {
    switch (position) {
      case 'top':
      case 'bottom':
        return selectedAlignment === 'right' ? 'right' : 'left';

      case 'right':
      case 'left':
        return selectedAlignment === 'bottom' ? 'bottom' : 'top';

      default:
        throw new Error('unsupported position <' + position + '>');
    }
  }

  _adjustBalloonInsetsToPosition(layoutInfo, targetElementBounds) {
    if (layoutInfo.position === 'top') {
      layoutInfo.top = '';
      layoutInfo.bottom = document.documentElement.clientHeight - targetElementBounds.top + 'px';
      return;
    }

    if (layoutInfo.position === 'bottom') {
      layoutInfo.bottom = '';
      layoutInfo.top = targetElementBounds.bottom + 'px';
      return;
    }

    if (layoutInfo.position === 'right') {
      layoutInfo.right = '';
      layoutInfo.left = targetElementBounds.right + 'px';
      return;
    }

    if (layoutInfo.position === 'left') {
      layoutInfo.left = '';
      layoutInfo.right = document.documentElement.clientWidth - targetElementBounds.left + 'px';
      return;
    }

    throw new Error('unsupported position <' + layoutInfo.position + '>');
  }

  _adjustBalloonInsetsToAlignment(layoutInfo, targetElementBounds) {
    const balloonAlignment = this._adjustAlignmentToPosition(layoutInfo.position, layoutInfo.alignment); // 37.5 px is from left+margin to tip middle


    const toTipMiddle = 37.5;

    if (balloonAlignment === 'right') {
      const rightSpace = document.documentElement.clientWidth - targetElementBounds.right;
      layoutInfo.right = rightSpace + targetElementBounds.width / 2 - toTipMiddle + 'px';
      layoutInfo.left = '';
      return;
    }

    if (balloonAlignment === 'left') {
      layoutInfo.right = '';
      layoutInfo.left = targetElementBounds.left + targetElementBounds.width / 2 - toTipMiddle + 'px';
      return;
    }

    if (balloonAlignment === 'bottom') {
      const bottomSpace = document.documentElement.clientHeight - targetElementBounds.bottom;
      layoutInfo.bottom = bottomSpace + targetElementBounds.height / 2 - toTipMiddle + 'px';
      layoutInfo.top = '';
      return;
    }

    if (balloonAlignment === 'top') {
      layoutInfo.bottom = '';
      layoutInfo.top = targetElementBounds.top + targetElementBounds.height / 2 - toTipMiddle + 'px';
      return;
    }

    throw new Error('unsupported alignment <' + balloonAlignment + '>');
  }

  _calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, priority) {
    if (priority.length === 0) {
      return computedPosition;
    }

    if (priority[0] === 'top') {
      if (position.topSpace < balloonHeight) {
        priority.splice(0, 1);
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, priority);
      } else {
        if (position.rightSpace < balloonWidth && position.leftSpace > position.rightSpace) {
          return {
            position: 'top',
            alignment: 'right'
          };
        } else {
          return {
            position: 'top',
            alignment: 'left'
          };
        }
      }
    } else if (priority[0] === 'bottom') {
      if (position.bottomSpace < balloonHeight) {
        priority.splice(0, 1);
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, priority);
      } else {
        if (position.rightSpace < balloonWidth && position.leftSpace > position.rightSpace) {
          return {
            position: 'bottom',
            alignment: 'right'
          };
        } else {
          return {
            position: 'bottom',
            alignment: 'left'
          };
        }
      }
    } else if (priority[0] === 'left') {
      if (position.topSpace < 0) {
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, ['bottom']);
      } else if (position.bottomSpace < 0) {
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, ['top']);
      } else if (position.leftSpace < balloonWidth) {
        priority.splice(0, 1);
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, priority);
      } else {
        if (position.topSpace < position.bottomSpace) {
          return {
            position: 'left',
            alignment: 'top'
          };
        } else {
          return {
            position: 'left',
            alignment: 'bottom'
          };
        }
      }
    } else if (priority[0] === 'right') {
      if (position.topSpace < 0) {
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, ['bottom']);
      } else if (position.bottomSpace < 0) {
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, ['top']);
      } else if (position.rightSpace < balloonWidth) {
        priority.splice(0, 1);
        return this._calcElementAlternatePosition(position, computedPosition, balloonWidth, balloonHeight, priority);
      } else {
        if (position.topSpace < position.bottomSpace) {
          return {
            position: 'right',
            alignment: 'top'
          };
        } else {
          return {
            position: 'right',
            alignment: 'bottom'
          };
        }
      }
    } else {
      return null; // should never happen
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "position", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'top';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "alignment", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'top';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "for", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'default';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "headline", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "show", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "modal", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "layoutInfo", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      top: '',
      bottom: '',
      left: '',
      right: '',
      position: 'top',
      alignment: 'top'
    };
  }
}), _applyDecoratedDescriptor(_class2.prototype, "iconIntereptor", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "iconIntereptor"), _class2.prototype)), _class2)) || _class);
